export default __webpack_public_path__ + "static/media/actualfood.7fc7be7e.png";